require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular/index.js
// module id = 440
// module chunks = 0